import "./ActionColumns.scss";

export const getActionColumn = (handleClickEdit, openModal, showFullActions = true, passRow = false) => [
  {
    field: "action",
    headerName: "Action",
    width: 200,
    renderCell: (params) => {
      const dataToSend = passRow ? params.row : params.row.id;

      return (
        <div className="cellAction">
          {showFullActions ? (
            <>
              <div className="editButton" onClick={() => handleClickEdit(dataToSend)}>Editar</div>
              <div className="deleteButton" onClick={() => openModal(dataToSend)}>Eliminar</div>
            </>
          ) : (
            <div className="viewButton" onClick={() => handleClickEdit(dataToSend)}>Ver</div>
          )}
        </div>
      );
    },
  },
];
